import React from 'react';
import { textUtils } from '../services/bookmarkService';

const BookmarkCard = ({ bookmark, onRemove }) => {
  const handleRemoveClick = () => {
    onRemove(bookmark.query_id);
  };

  return (
    <div className="bookmark-card" data-query-id={bookmark.query_id}>
      <div className="card-header">
        <button 
          className="remove-bookmark-btn" 
          title="Remove bookmark"
          onClick={handleRemoveClick}
        >
          Remove Bookmark
        </button>
      </div>
      
      <div className="query-section">
        <div className="section-label">Query</div>
        <div className="query-text">{textUtils.escapeHtml(bookmark.query)}</div>
      </div>
      
      <div className="query-section">
        <div className="section-label">Response</div>
        <div 
          className="response-text" 
          dangerouslySetInnerHTML={{ __html: bookmark.response }}
        />
      </div>
      
      <div className="query-section">
        <div className="section-label">Reference Links</div>
        <div className="reference-links">
          {bookmark['Reference links'] && bookmark['Reference links'].trim() ? (
            <a 
              href={bookmark['Reference links']} 
              target="_blank" 
              rel="noopener noreferrer"
            >
              {textUtils.escapeHtml(bookmark['Reference links'])}
            </a>
          ) : (
            <span className="no-reference">No reference links available</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default BookmarkCard;